(function(){
  var fmt=new Intl.NumberFormat('pl-PL',{style:'currency',currency:'PLN'});
  function data(r){if(!r._d){try{r._d=JSON.parse(r.querySelector('[data-pdp-data]').textContent);}catch(e){r._d=[];}}return r._d;}
  function cur(r){return r._i||0;}
  function render(r){
    var d=data(r),i=cur(r);
    r.querySelectorAll('[data-pdp-var]').forEach(function(b){b.setAttribute('aria-pressed',String(parseInt(b.dataset.idx,10)===i));});
    r.querySelectorAll('[data-pdp-price]').forEach(function(e){e.textContent=d[i]?fmt.format(d[i].price/100):'';});
  }
  function setMain(r,t){
    var img=r.querySelector('[data-pdp-main]');
    if(img){img.src=t.dataset.src;img.removeAttribute('srcset');img.alt=t.dataset.alt||'';}
    r.querySelectorAll('[data-pdp-thumb]').forEach(function(x){x.setAttribute('aria-current',String(x===t));});
  }
  function media(r,id){var t=r.querySelector('[data-pdp-thumb][data-media="'+id+'"]');if(t){setMain(r,t);}}
  document.addEventListener('click',function(e){
    var a=e.target.closest('[data-pdp-add]');
    var r=e.target.closest('[data-pdp]')||(a?document.querySelector('[data-pdp]'):null);
    if(!r){return;}
    var v=e.target.closest('[data-pdp-var]');
    if(v){r._i=parseInt(v.dataset.idx,10);var dv=data(r)[r._i];if(dv&&dv.media){media(r,dv.media);}render(r);return;}
    var t=e.target.closest('[data-pdp-thumb]');
    if(t){setMain(r,t);return;}
    if(a){
      var d=data(r)[cur(r)];
      if(!d){return;}
      a.disabled=true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:d.id,quantity:1}]})})
        .then(function(x){if(!x.ok){throw new Error('cart');}return x.json();})
        .then(function(){window.location.href='/cart';})
        .catch(function(){a.disabled=false;alert('Nie udało się dodać do koszyka. Spróbuj ponownie.');});
    }
  });
  function init(){document.querySelectorAll('[data-pdp]').forEach(render);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  document.addEventListener('shopify:section:load',init);
})();
